"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.isUpdatingAssetMetadata = exports.isMinorPublished = exports.isMinorDeprecated = exports.isLoadingVersionsDependents = exports.isLoadingVersionsDependencies = exports.isLoadingVersionGroups = exports.isLoadingMinorVersions = exports.isLoadingLifecycleStateActions = exports.isLoadingLifecycleState = exports.isDeletingAsset = exports.isAddingToPublicPortal = exports.canShowEdition = exports.canEdit = exports.canAdmin = exports.assetVersionsDependents = exports.assetVersionsDependencies = exports.assetVersions = exports.assetVersionGroups = exports.assetUI = exports.assetOrganizationDomain = exports.assetMinorVersions = exports.asset = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _reselect = require("reselect");
var _actionify = require("@mulesoft/actionify");
var _semver = _interopRequireDefault(require("semver"));
var sessionSelectors = _interopRequireWildcard(require("../session/selectors"));
var _assets = require("../../utils/assets");
var _objects = require("../../utils/objects");
var _utils = require("./utils");
var actionTypes = _interopRequireWildcard(require("./actionTypes"));
var _arrays = require("../../utils/arrays");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // eslint-disable-next-line import/no-extraneous-dependencies
var emptyArray = [];
var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object';
var assetUI = exports.assetUI = function assetUI(state) {
  return state.assets.detail.ui;
};
var isUpdatingAssetMetadata = exports.isUpdatingAssetMetadata = (0, _actionify.createRequestLoadingSelector)(actionTypes.UPDATE_METADATA, function (requestParams, params) {
  return requestParams.asset.groupId === params.groupId && requestParams.asset.assetId === params.assetId;
});
var isLoadingVersionGroups = exports.isLoadingVersionGroups = function isLoadingVersionGroups(state) {
  return state.assets.visibility.ui.isLoadingVersionGroups;
};
var isLoadingVersionsDependencies = exports.isLoadingVersionsDependencies = function isLoadingVersionsDependencies(state) {
  return state.assets.visibility.ui.isLoadingVersionsDependencies;
};
var isLoadingVersionsDependents = exports.isLoadingVersionsDependents = function isLoadingVersionsDependents(state) {
  return state.assets.visibility.ui.isLoadingVersionsDependents;
};
var isLoadingMinorVersions = exports.isLoadingMinorVersions = (0, _actionify.createRequestLoadingSelector)(actionTypes.GET_MINOR_VERSIONS);
var isAddingToPublicPortal = exports.isAddingToPublicPortal = function isAddingToPublicPortal(state) {
  return state.assets.visibility.ui.isAddingToPublicPortal;
};
var isDeletingAsset = exports.isDeletingAsset = function isDeletingAsset(state) {
  return state.assets.detail.ui.isDeletingAsset;
};
var isLoadingLifecycleState = exports.isLoadingLifecycleState = (0, _actionify.createRequestLoadingSelector)(actionTypes.UPDATE_STATUS, function (requestParams, params) {
  return requestParams.asset.groupId === params.groupId && requestParams.asset.assetId === params.assetId && requestParams.asset.version === params.version;
});
var isLoadingLifecycleStateActions = exports.isLoadingLifecycleStateActions = (0, _actionify.createRequestLoadingSelector)(actionTypes.GET_LIFECYCLE_STATES_ACTIONS, function (requestParams, params) {
  return requestParams.groupId === params.groupId && requestParams.assetId === params.assetId && requestParams.version === params.version;
});
var assetParent = function assetParent(state, params) {
  return state.assets.detail.data[(0, _assets.getGAKey)({
    groupId: params.groupId,
    assetId: params.assetId
  })];
};
var assetVersionAgnosticProps = (0, _reselect.createSelector)(assetParent, function ($assetParent) {
  return $assetParent && (0, _objects.omit)($assetParent, 'versions');
});
var minorVersions = function minorVersions(state, _ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId;
  return state.assets.visibility.minorVersions[(0, _assets.getGAKey)({
    groupId: groupId,
    assetId: assetId
  })] || emptyArray;
};
var getVersions = function getVersions($assetParent, $minorVersions, includeDeleted) {
  return Object.keys($assetParent.versions).filter(function (version) {
    return includeDeleted || !$assetParent.versions[version].isDeleted;
  }).map(function (version) {
    var effectiveVersion = $assetParent.versions[version];
    var isPublic = $minorVersions.some(function (assetMinorVersion) {
      return assetMinorVersion.isPublic && assetMinorVersion.minorVersion === effectiveVersion.minorVersion;
    });
    return _objectSpread(_objectSpread({
      version: version
    }, $assetParent.versions[version]), {}, {
      isPublic: isPublic
    });
  }).sort(function (v1, v2) {
    return _semver.default.rcompare(v1.version, v2.version);
  });
};
var memoizedAllAssetVersions = (0, _memoizeOne.default)(function ($assetParent, $minorVersions, includeDeleted) {
  if (!$assetParent || !$assetParent.versions) {
    return emptyArray;
  }
  return getVersions($assetParent, $minorVersions, includeDeleted);
});
var memoizedMinorAssetVersions = (0, _memoizeOne.default)(function ($assetParent, $minorVersions, minorVersion, includeDeleted) {
  if (!$assetParent || !$assetParent.versions) {
    return emptyArray;
  }
  return getVersions($assetParent, $minorVersions, includeDeleted).filter(function (version) {
    return version.minorVersion === minorVersion;
  });
});
var assetVersions = exports.assetVersions = (0, _reselect.createSelector)(assetParent, minorVersions, function (state, params) {
  if (params.minorVersion) {
    return params.minorVersion;
  }
  if (params.version) {
    var _params$version$split = params.version.split('.'),
      _params$version$split2 = (0, _slicedToArray2.default)(_params$version$split, 2),
      major = _params$version$split2[0],
      minor = _params$version$split2[1];
    return "".concat(major, ".").concat(minor);
  }
  return null;
}, function (state, params) {
  return params.includeDeleted;
}, function ($assetParent, $minorVersions, minorVersion, includeDeleted) {
  if (!$assetParent || !$assetParent.versions) {
    return emptyArray;
  }
  if (minorVersion) {
    return memoizedMinorAssetVersions($assetParent, $minorVersions, minorVersion, includeDeleted);
  }
  return memoizedAllAssetVersions($assetParent, $minorVersions, includeDeleted);
});
var memoizedAssetParams = (0, _memoizeOne.default)(function (groupId, assetId, minorVersion, status) {
  return {
    includeDeleted: true,
    groupId: groupId,
    assetId: assetId,
    minorVersion: minorVersion,
    status: status
  };
});
var isMinorDeprecated = exports.isMinorDeprecated = (0, _reselect.createSelector)(function (state, params) {
  return assetVersions(state, memoizedAssetParams(params.groupId, params.assetId, params.minorVersion, params.status));
}, function ($assetVersions) {
  return !!$assetVersions.length && $assetVersions.every(function (asset) {
    return asset.status === 'deprecated';
  });
});
var isMinorPublished = exports.isMinorPublished = (0, _reselect.createSelector)(function (state, params) {
  return assetVersions(state, memoizedAssetParams(params.groupId, params.assetId, params.minorVersion, params.status));
}, function ($assetVersions) {
  return $assetVersions.every(function (asset) {
    return asset.status === 'published';
  });
});
var assetVersionsMap = new Map();
var assetMap = new Map();
var lastAssetParent;
var asset = exports.asset = function asset(state, params) {
  var groupId = params.groupId,
    assetId = params.assetId,
    minorVersion = params.minorVersion,
    status = params.status,
    version = params.version,
    versionGroup = params.versionGroup;
  var $assetVersions = assetVersions(state, memoizedAssetParams(params.groupId, params.assetId, params.minorVersion, params.status));
  var $assetParent = assetParent(state, params);
  var $versionAgnosticProps = assetVersionAgnosticProps(state, params);
  if (!$assetParent) {
    return null;
  }

  // if empty, then set
  if (!lastAssetParent) {
    lastAssetParent = $assetParent;
  }

  // if parent changed, then everything changed
  if (isClient && $assetParent !== lastAssetParent) {
    lastAssetParent = $assetParent;
    assetVersionsMap.clear();
    assetMap.clear();
  }
  var key = [groupId, assetId, minorVersion !== null && minorVersion !== void 0 ? minorVersion : 'no-minor', status !== null && status !== void 0 ? status : 'no-status', version !== null && version !== void 0 ? version : 'no-version', versionGroup !== null && versionGroup !== void 0 ? versionGroup : 'no-group'].join(':');

  // we don't want caching in the server to avoid leaks
  if (isClient) {
    var assetVersionsFromCache = assetVersionsMap.get(key);

    // if versions (the source) is the same, then the result is the same
    if (assetVersionsFromCache === $assetVersions) {
      return assetMap.get(key);
    }
    assetVersionsMap.set(key, $assetVersions);
  }
  var $asset;
  if (version) {
    $asset = $assetParent.versions[version];
  } else {
    var _nonDeletedVersions$f;
    var nonDeletedVersions = $assetVersions.filter(function (assetVersion) {
      return !assetVersion.isDeleted;
    });
    var statuses = (0, _arrays.convertToArray)(status);
    var byStatus = function byStatus(assetVersion) {
      return statuses.length ? statuses.some(function ($status) {
        return $status === assetVersion.status;
      }) : true;
    };
    $asset = (_nonDeletedVersions$f = nonDeletedVersions.filter(byStatus)[0]) !== null && _nonDeletedVersions$f !== void 0 ? _nonDeletedVersions$f : $assetVersions.filter(byStatus)[0];
  }
  if ($asset) {
    var _result = _objectSpread(_objectSpread({
      versions: $assetVersions
    }, $asset), $versionAgnosticProps);
    if (isClient) {
      assetMap.set(key, _result);
    }
    return _result;
  }

  // this state represents a transition, where only the asset agnostic props are used to render the portal
  var result = _objectSpread({
    version: version,
    minorVersion: minorVersion,
    versionGroup: versionGroup,
    isMinorVersionTransition: true
  }, (0, _utils.extractAssetAgnosticProperties)($versionAgnosticProps));
  if (isClient) {
    assetMap.set(key, result);
  }
  return result;
};
var version = exports.version = (0, _reselect.createSelector)(asset, function (state, props) {
  return props.version;
}, function ($asset, $version) {
  return $version || $asset && $asset.version;
});
var assetOrganizationDomain = exports.assetOrganizationDomain = (0, _reselect.createSelector)(assetParent, function ($asset) {
  return $asset && $asset.organization.domain;
});
var assetVersionsDependencies = exports.assetVersionsDependencies = function assetVersionsDependencies(state, _ref2) {
  var groupId = _ref2.groupId,
    assetId = _ref2.assetId;
  var key = (0, _assets.getGAKey)({
    groupId: groupId,
    assetId: assetId
  });
  return state.assets.visibility.versionsDependencies[key];
};
var assetVersionsDependents = exports.assetVersionsDependents = function assetVersionsDependents(state, _ref3) {
  var groupId = _ref3.groupId,
    assetId = _ref3.assetId;
  var key = (0, _assets.getGAKey)({
    groupId: groupId,
    assetId: assetId
  });
  return state.assets.visibility.versionsDependents[key];
};
var assetMinorVersions = exports.assetMinorVersions = (0, _reselect.createSelector)(minorVersions, function (state, params) {
  return assetVersions(state, memoizedAssetParams(params.groupId, params.assetId, null));
}, function ($minorVersions, $versions) {
  if (!$minorVersions) {
    return null;
  }
  return $minorVersions.reduce(function (accum, minorVersionInfo) {
    var versionsFilteredByMinor = $versions.filter(function ($version) {
      return $version.minorVersion === minorVersionInfo.minorVersion;
    });
    var nonDeletedVersions = versionsFilteredByMinor.filter(function ($version) {
      return !$version.isDeleted;
    });
    if (versionsFilteredByMinor.length > 0 && nonDeletedVersions.length === 0) {
      return accum;
    }
    return [].concat((0, _toConsumableArray2.default)(accum), [minorVersionInfo]);
  }, []);
});
var assetVersionGroups = exports.assetVersionGroups = (0, _reselect.createSelector)(assetMinorVersions, function ($minorVersions) {
  if (!$minorVersions) {
    return null;
  }
  var versionGroups = {};
  $minorVersions.forEach(function (minorVersion) {
    var majorVersion = parseInt(minorVersion.minorVersion.split('.')[0], 10);
    var versionGroup = versionGroups[majorVersion];
    if (!versionGroup) {
      versionGroups[majorVersion] = {
        major: majorVersion,
        organizationId: minorVersion.organizationId,
        groupId: minorVersion.groupId,
        assetId: minorVersion.assetId,
        versionGroup: minorVersion.versionGroup,
        isPublic: minorVersion.isPublic
      };
    } else {
      versionGroups[majorVersion].isPublic = versionGroups[majorVersion].isPublic || minorVersion.isPublic;
    }
  });
  return Object.values(versionGroups);
});
var canEdit = exports.canEdit = (0, _reselect.createSelector)(sessionSelectors.isStudio, asset, function ($isStudio, $asset) {
  return !$isStudio && $asset && $asset.permissions && $asset.permissions.indexOf('edit') !== -1;
});
var canShowEdition = exports.canShowEdition = (0, _reselect.createSelector)(sessionSelectors.isPublicPortal, canEdit, function (isPublicPortal, $canEdit) {
  return $canEdit && !isPublicPortal;
});
var canAdmin = exports.canAdmin = (0, _reselect.createSelector)(sessionSelectors.isStudio, asset, function ($isStudio, $asset) {
  return !$isStudio && !!$asset && Array.isArray($asset.permissions) && $asset.permissions.indexOf('admin') !== -1;
});
//# sourceMappingURL=selectors.js.map